import { isCanada } from '../../../../utils';

// 9fbef606107a605d69c0edbcd8029e5d
const placeCard = 'place-card-small';
const placeCardPJP = 'place-card-pjp-small';
const giftCardCountry = isCanada() ? 'gift-card-two-brand' : 'gift-card-small';
const cardIconMapping = {
  DISC: 'disc-small',
  MC: 'mc-small',
  'Master Card': 'mc-small',
  Discover: 'disc-small',
  Amex: 'amex-small',
  Visa: 'visa-small',
  Placecard: placeCard,
  Placecard_PJP: placeCardPJP,
  GC: giftCardCountry,
  'PLACE CARD': placeCard,
  'MY PLACE REWARDS CREDIT CARD': placeCard,
  VENMO: 'venmo-blue-acceptance-mark',
};
export default cardIconMapping;
